import { render, staticRenderFns } from "./crm.vue?vue&type=template&id=7e7b1150&scoped=true&"
import script from "./crm.vue?vue&type=script&lang=js&"
export * from "./crm.vue?vue&type=script&lang=js&"
import style0 from "./crm.vue?vue&type=style&index=0&id=7e7b1150&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e7b1150",
  null
  
)

export default component.exports